import { useCallback } from 'react'
import { Box, Grid } from '@mui/material'
import { PlatformEvent } from 'lib/util'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'
import { makeBreakable } from 'lib/util/string'

const styles = theme => ({
  container: {
    marginVertical: '4px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '1rem',
  },
  actions: {
    gap: '0.5rem',
  },
  icon: {
    width: '3rem',
    height: '3rem',
  },
  chevron: {
    alignItems: 'center',
    width: '1.5rem',
    height: '1.5rem',
  },
})

/**
 * Displays actions.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellFavoriteActions = (classes, props = {}) => {
  const { rowHovered, docType, favoriteDescription, events } = props
  const { onFavoriteClick = null, onDescriptionClick = null } = events || {}

  /**
   * Creates a platform event based on the incoming `event`.
   *
   * @param {Event} event     incoming event
   * @param {Boolean} remove  whether to remove the item
   * @returns {PlatformEvent}
   */
  const _getEvent = useCallback((event, remove) => new PlatformEvent(
    event,
    { payload: props.id, options: { type: docType, description: favoriteDescription, delete: remove } },
  ), [])

  const handleFavorite = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    onFavoriteClick?.(_getEvent(e, true))
  }, [onFavoriteClick])

  const handleDescription = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    onDescriptionClick?.(_getEvent(e, false))
  }, [onDescriptionClick])

  return (
    <Grid
      container
      className={classes.container}
    >
      <Grid
        item
        container
        xs={'auto'}
        className={classes.actions}
        sx={{ opacity: rowHovered ? 1 : 0 }}
      >
        <Grid
          item
          xs={'auto'}
          component={Box}
          className={classes.icon}
          onClick={handleFavorite}
        >
          <Icon
            rounded={true}
            color={'signal'}
            background={'white'}
            source={'favorite-filled'}
          />
        </Grid>
        <Grid
          item
          xs={'auto'}
          component={Box}
          className={classes.icon}
          onClick={handleDescription}
        >
          <Icon
            rounded={true}
            color={'black'}
            source={'edit'}
            background={'white'}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={'auto'}
        className={classes.chevron}
      >
        <Icon
          color={'gray.500'}
          source={'chevron-right'}
        />
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellFavoriteActions, styles)
